(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["voltacon-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ease = (p) => 1 - Math.pow(1 - p, 3);

    // ----- reveal -----
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    // ----- count up -----
    const countUp = (el) => {
      const text = el.textContent.trim();
      const m = text.match(/^([^\d]*)([\d,]+(?:\.\d+)?)(.*)$/s);
      if (!m) return;
      const [, pre, num, post] = m;
      if (/[A-Za-z]/.test(pre)) return;
      const target = parseFloat(num.replace(/,/g, ''));
      if (!isFinite(target)) return;
      const commas = num.includes(',');
      const decimals = (num.split('.')[1] || '').length;
      const isYear = /^\d{4}$/.test(num) && target > 1900 && target < 2100;
      const from = isYear ? target - 40 : 0;
      const fmt = (v) => {
        let s = v.toFixed(decimals);
        if (commas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return pre + s + post;
      };
      const start = performance.now();
      const dur = 1500;
      const step = (now) => {
        const p = Math.min(1, (now - start) / dur);
        el.textContent = fmt(from + (target - from) * ease(p));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    const cio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        countUp(e.target);
      });
    }, { threshold: 0.5 });

    // ----- images settle in -----
    const settle = (img) => {
      const done = () => img.setAttribute('data-loaded', '');
      if (img.complete) done(); else img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    };

    // ----- reading progress -----
    const progress = () => {
      const target = document.querySelector('[data-reading-progress]');
      if (!target || reduced || document.querySelector('.vm-progress')) return;
      const bar = document.createElement('div');
      bar.className = 'vm-progress';
      bar.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bar);
      const update = () => {
        const r = target.getBoundingClientRect();
        const total = r.height - window.innerHeight;
        const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
        bar.style.transform = `scaleX(${p})`;
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    const arm = (scope) => {
      scope.querySelectorAll('[data-stagger]').forEach((g) => {
        [...g.children].forEach((c, i) => c.style.setProperty('--i', i));
      });
      scope.querySelectorAll('[data-reveal], [data-stagger]').forEach((el) => {
        if (reduced) el.classList.add('is-in'); else io.observe(el);
      });
      scope.querySelectorAll('[data-count]:not([data-counted])').forEach((el) => {
        el.setAttribute('data-counted', '');
        if (!reduced) cio.observe(el);
      });
      scope.querySelectorAll('img[loading="lazy"]:not([data-loaded])').forEach(settle);
    };

    // Images added after load (a carousel swapping a still, say) never reached
    // settle(), so the CSS above left them at opacity 0 for good. Watch for them.
    const watchLate = () => {
      const mo = new MutationObserver((records) => {
        records.forEach((rec) => {
          rec.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'IMG' && node.loading === 'lazy' && !node.hasAttribute('data-loaded')) settle(node);
            node.querySelectorAll?.('img[loading="lazy"]:not([data-loaded])').forEach(settle);
          });
        });
      });
      mo.observe(document.body, { childList: true, subtree: true });
    };

    const boot = () => { arm(document); progress(); watchLate(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    // theme editor re-renders a section in place
    document.addEventListener('shopify:section:load', (e) => arm(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
